/* eslint-disable */
import Quill from "quill";
import { stickers_sets } from "@/components/chat/utils/stickers-config";
import { readDataFromClipboard } from "@/utils/clipOperate";
import { lookup } from "mime-types";
import { message as AntMessage } from "antd";
import events from "@/components/Joyspace/context/events";
import { FocusSDK, isFocusEnv } from "@/utils";
import { getFileIconByMime } from "@/utils/chat/index";
import UAParser from "ua-parser-js";
import bus from "@/utils/bus";
import { handleDealPasteData } from "@/baseComponents/JEditor/dealPasteData";

const Clipboard = Quill.import("modules/clipboard");
const Delta = Quill.import("delta");

function getNewStr(str: string, replaceStr: string) {
  let newStr = "";
  let len = replaceStr.length;
  let firstIndex = str.indexOf(replaceStr);
  console.log("firstIndex", firstIndex);
  if (firstIndex < 0) {
    return str;
  }
  newStr =
    str.substring(0, firstIndex) +
    `<span class="e-emoji" contenteditable="false" data-value="${replaceStr}">&#65279;<span contenteditable="false">${replaceStr}</span>&#65279;</span>`;
  let nextStr = str.substring(firstIndex + len);
  let tmpStr = "";
  if (nextStr) {
    tmpStr = getNewStr(nextStr, replaceStr);
  }
  newStr += tmpStr;
  return newStr;
}

// 获取剪贴板文件
export async function getClipImgFile(type: string) {
  try {
    let blobData = (await readDataFromClipboard()) || [];
    let fileBlob: any;
    let fileName: any;

    for (let item of blobData) {
      let itemType = item?.type || "";
      if (itemType.indexOf("image/") > -1) {
        fileBlob = item;
      } else if (itemType.indexOf("text/plain") > -1) {
        fileName = await item?.text();
      }
    }

    if (fileBlob) {
      console.log("blob---", fileBlob, fileName, type);
      let file = new window.File([fileBlob], fileName, { type: type });
      return file;
    }
    return null;
  } catch (e) {
    console.error(e);
    return null;
  }
}

// 国产操作系统且是文件
export function isLinuxAndFile(text: string) {
  let browserInfo = window.navigator?.userAgent;

  if (/linux/i.test(browserInfo)) {
    if (text.startsWith("/") && lookup(text)) {
      return true;
    }
  }

  return false;
}
export default class CustomClipboard extends Clipboard {
  constructor(quill: any, options: any) {
    super(quill, options);
    this.options = options;
    this.upload = options.upload;
  }

  async onPaste(e: any) {
    // await readDataFromClipboard();
    if (e.defaultPrevented || !this.quill.isEnabled()) return;
    e.preventDefault();
    let range = this.quill.getSelection();
    const tablePasteFormat =
      (isFocusEnv()
        ? JSON.parse(FocusSDK.getConfigData())?.tablePasteFormat
        : localStorage.getItem("tablePasteFormat")) || "text";
    // isFocusEnv() && FocusSDK.clipboadMultiple();
    // let newFile: any;
    // bus
    //   .off("work:comment-inputcomment-jeditor-modules-clipboard")
    //   .on("work:comment-inputcomment-jeditor-modules-clipboard", (data) => {
    //     newFile = data;
    //   });
    let pasteType = "shortCut";
    bus.off("changePasteType").on("changePasteType", (data) => {
      pasteType = data;
    });
    const html = e.clipboardData.getData("text/html");
    let text = e.clipboardData.getData("text/plain");
    const quillJson = e.clipboardData.getData("text/quill");
    const files = Array.from(e.clipboardData.files || []);

    setTimeout(async () => {
      if (pasteType === "shortCut") {
        if (!html && !text && files.length === 0) {
          AntMessage.error("受系统剪切板大小限制，不支持该次粘贴操作");
          return;
        }
        if (!html && !text && files.length > 0) {
          if (this.upload) {
            console.log("上传图片");
            this.upload(range, files);
          }
          return;
        }
      }
      // 判断是否仅为图片
      const doc = new DOMParser().parseFromString(html, "text/html");
      const container = doc.body;
      // if (
      //   container &&
      //   container.childNodes.length === 1 &&
      //   container.firstChild &&
      //   container.firstChild.nodeName === "IMG" &&
      //   files.length > 0
      // ) {
      //   if (this.upload) {
      //     this.upload(range, files);
      //   }
      //   return;
      // }
      if (container && files.length > 0) {
        if (container.childElementCount === 1) {
          if (
            container.firstElementChild?.tagName.toLocaleUpperCase() === "IMG" &&
            pasteType === "shortCut"
          ) {
            if (this.upload) {
              this.upload(range, files);
            }
            return;
          } else if (container.firstElementChild?.tagName.toLocaleUpperCase() === "TABLE") {
            if (pasteType === "click") {
              bus.emit("available:table-to-img", files);
            } else {
              if (tablePasteFormat === "image") {
                this.upload(range, files, "table");
                return;
              }
            }
          }
        }
      }
      const emojiImg = container.querySelectorAll(".e-emoji");
      if (emojiImg.length > 0 && doc.querySelectorAll("p").length === 0) {
        emojiImg.forEach((item) => {
          let tempDiv = document.createTextNode(item.getAttribute("data-value") || "");
          container.replaceChild(tempDiv, item);
          text = container.textContent?.replace(/\r|\n/gi, "");
        });
      }
      if (pasteType === "click") {
        const _this = this;
        bus.emit("click:paste", { range, html, text, files, doc, _this, quillJson });
      } else {
        // isFocusEnv() && FocusSDK.clipboadMultiple();
        if (text) {
          let type: any = lookup(text) || "";
          if (type.match(/^image\/(gif|jpe?g|a?png)/i)) {
            let file = await getClipImgFile(type);
            // console.log('file---', file);
            if (file) {
              return this.upload(range, [file]);
            }
          }
          // 国产操作系统且是文件但获取不到剪贴板文件
          if (isLinuxAndFile(text)) {
            text = "";
            AntMessage.warn("当前浏览器不支持粘贴文件，请拖拽文件至当前窗口");
            return;
          }
        }
        const _this = this;
        handleDealPasteData({ range, html, text, doc, _this, quillJson });
      }
    }, 300);
  }
}
